/* global axios */
import ApiClient from '../ApiClient';

class WgptAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, wgpt: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  getLimits() {
    return axios.get(`${this.url}limits`);
  }

  // Listing-credit wallet for hubpost_cars accounts.
  listingCredits() {
    return axios.get(`${this.url}listing_credits`);
  }

  listingCheckout(packageId) {
    return axios.post(`${this.url}listing_checkout`, { package_id: packageId });
  }

  listingCreditInvoice(creditId) {
    return axios.get(`${this.url}listing_credit_invoice`, {
      params: { credit_id: creditId },
    });
  }

  // Added as a placeholder for the future
  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }
}

export default new WgptAccountAPI();
